const mutations = {
  'SET_SERVICES' (state, { services }) {
    state.services = services;
  },
  'SET_SERVICE' (state, { service }) {
    state.service = service;
  }
}

export default mutations